import { mapCustomInteractionTypesToDjangIO } from "shared/djangio/helpers"
import { DjangIOCache } from "_djangio_cache_new_grassroots.ts"
import Instance from "shared/djangio/Instance"

const DjangIO = new Instance(DjangIOCache)
global.DjangIO = DjangIO
window.DjangIO = DjangIO

mapCustomInteractionTypesToDjangIO()
